/*
 * @Author: daringuo
 * @Date: 2018-05-15 18:55:19
 * @Last Modified by:   daringuo
 * @Last Modified time: 2018-05-15 18:55:19
 */
import reqwest from 'reqwest';

let isSending = false;
let allData = null;
let cbStacks = [];
export const getAllData = (fn) => {
  if (allData) {
    fn(allData);
    return;
  }
  if (isSending) {
    cbStacks.push(fn);
    return;
  }
  isSending = true;
  reqwest({
    url: '/data_query',    //线上API
    // url: '//game.browser.qq.com/data_query',    //线上API
    // url: '//qbgame.sparta.html5.qq.com/data_query', //测试环境API
    type: 'json',
    method: 'GET',
    crossOrigin: true,
    success(res) {
      isSending = false;
      if (res.error === 0) {
        allData = res;
      }
      cbStacks.forEach((item) => {
        item(res);
      });
      cbStacks = [];
      fn(res);
    },
    error(e) {
      isSending = false;
      cbStacks.forEach((item) => {
        item(e);
      });
      cbStacks = [];
      fn(e);
    }
  });
};

export default {
  getData(moduleName, fn) {
    getAllData((res) => {
      if (res && res.error === 0 && res.data) {
        switch (moduleName) {
          case 'game-banner':
            if (res.data.banner) {
              fn(res.data.banner);
            }
            break;
          case 'game-user-profile':
            if (res.data.web_game_for_you) {
              fn(res.data.web_game_for_you);
            }
            break;
          case 'game-web-list':
            if (res.data.web_game_hot) {
              fn(res.data.web_game_hot);
            }
            break;
          case 'game-server-notice':
            if (res.data.server) {
              fn(res.data.server);
            }
            break;
          case 'game-hot-rank':
            if (res.data.rank_web) {
              fn(res.data.rank_web);
            }
            break;
          case 'game-network-list':
            if (res.data.pc_game) {
              fn(res.data.pc_game);
            }
            break;
          case 'game-pc-phone':
            if (res.data.mobile_game) {
              fn(res.data.mobile_game);
            }
            break;
          case 'game-all-list':
            if (res.data.all_list) {
              fn(res.data.all_list);
            }
            break;
          // 推荐新游
          case 'game-recommend-latest':
            if (res.data.web_game_latest) {
              fn(res.data.web_game_latest);
            }
            break;
          // 广告
          case 'game-ad':
            if (res.data.ad) {
              fn(res.data.ad);
            }
            break;
          // 手游广告
          case 'mobile-game-ad':
            if (res.data.game_ad) {
              fn(res.data.game_ad);
            }
            break;
          // 开屏广告
          case 'open_screen':
            if (res.data.open_screen) {
              fn(res.data.open_screen);
            }
            break;
          // H5游戏
          case 'h5_game':
            if (res.data.h5_game) {
              fn(res.data.h5_game);
            }
            break;
          default:
            fn({});
            break;
        }
      }
      else {
        fn({});
      }
    });
  },
  getGameDetail(id, cb) {
    reqwest({
      url: '//appstore.browser.qq.com/getappdetailbatch',
      data: '{"pkgNameList":["' + id + '"]}',
      method: 'POST',
      crossOrigin: true,
      success(res) {
        if (res.ret === 0 && res.mpRes && res.mpRes[id]) {
           return cb(res.mpRes[id])
        }
        cb({})
      },
      error(e) {
        cb({})
      }
    });
  },
  getOpenScreenAdData(cb) {
    $.ajax({
      url: 'https://show-g.mediav.com/s?type=1&of=4&newf=1&scheme=https&showid=w1I5KU&reqtimes=1&impct=1&jsonp=cb',
      type: 'GET',
      dataType: 'jsonp',
      jsonpCallback: 'cb',
      success: function (res) {
        if (res && res.ads && res.ads.length) {
          cb(res.ads[0])
        }
      },
      error: function () {
        cb(null)
      }
    })
  },
  getGameBoxCmsData(cb) {
    let compare = function(prop) {
      return function(obj1, obj2) {
        let val1 = obj1[prop]
        let val2 = obj2[prop]
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1)
          val2 = Number(val2)
        }
        if (val1 < val2) {
          return -1
        } else if (val1 > val2) {
          return 1
        } else {
          return 0
        }
      }
    }

    fetch(`https://stdl.qq.com/stdl/unioncms/300033/jsonfile_300033.json?t=${new Date().getHours()}`).then((resp) => {
      if (resp.status === 200 && resp.ok) {
        return resp.json()
      }
    }).then((data) => {
      return JSON.parse(data.jsonfile_data)
    }).then((data) => {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          let element = data[key]
          if (Array.isArray(element) && element[0] && element[0].constructor === Object && element[0].hasOwnProperty('weight')) {
            element = element.sort(compare('weight'))
          }
        }
      }
      cb(data)
    }).catch((e) => {
      cb({})
    })
  }
}